import React from "react";
import { useNavigate } from "react-router-dom";

import { Box, Grid } from "@mui/material";
import { Typography } from "@mui/material";
import rightArrow from "assets/icons/arrow-right-landing.png";
import Image5 from "assets/images/uberuns.png";
import ContactCard from "components/common/contactCard";
import SingleImageBox from "components/common/singleImageBox";

const DigitalSolutionB = () => {
  const navigate = useNavigate();
  return (
    <div className="ds">
      <Grid container className="digital-solution-page-b ">
        <Grid item sm={5} xs={6} className="padded-container6 left-align padding-left-col">
          <Box component="div" className="simple-box">
            <Typography variant="h3" className="heading ">
              Über uns
            </Typography>
            <Typography variant="subtitle2" className="sub-heading ">
              Transformation is coming…mit der Volksbank Digital Solutions GmbH!
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Mit der Volksbank Digital Solutions GmbH möchte die Volksbank pur eG neue Wege gehen.
              Dabei steht die Entwicklung neuer Geschäftsmodelle sowie digitaler Lösungen im Fokus,
              die über traditionelle Bankthemen hinaus gehen und neue Geschäftsbereiche „beyond
              banking“ erschließen.
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Mit der ILI.DIGITAL AG hat die Volksbank pur einen starken Partner als
              Mit-Gesellschafter gefunden, der viel Expertise und Fachwissen rund um digitale
              Geschäftsmodelle und IT-Entwicklung mitbringt.
            </Typography>
          </Box>
        </Grid>

        <Grid
          item
          md={7}
          xs={6}
          sx={{
            display: "block",
            paddingBottom: "2rem !important",
            marginTop: "60px",
          }}
          className="left-align padding-left-col">
          <SingleImageBox classNameProp={"uber-uns-img"} imgSrc={Image5}></SingleImageBox>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                marginLeft: "2rem",
                // width: "100%",
                // maxWidth: "240px",
              }}>
              <ContactCard
                name="Meike Weichselmann"
                title="Innovations-Managerin"

                // company="Zitat Platzhalter"
              />

              <ContactCard
                name="Stefan Spohrer"
                title="Geschäftsführer"

                // company="Zitat Platzhalter"
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                // width: "100%",
                // maxWidth: "280px",
              }}>
              <ContactCard
                name="Jennifer Leger"
                title="Innovations-Managerin"

                // company="Zitat Platzhalter"
              />
              <ContactCard
                name="Andreas Lorenz"
                title="Geschäftsführer"

                // company="Zitat Platzhalter"
              />
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{ display: "flex", width: "100%", paddingTop: "0 !important" }}
          className="left-align padding-left-col">
          <Box component="div" className="animated-link">
            <Typography variant="subtitle2" className="link-text">
              Kontakt
            </Typography>
            <Box className="right-arrow" onClick={() => navigate("/digitalsolution")}>
              <img src={rightArrow} width="25px" />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default DigitalSolutionB;
